<div class="sign-container">
  <h1>Vertrag</h1>
  <p>Vertragsbeginn: {{validFrom | date:'longDate':'':'de-DE'}}</p>
  <p *ngIf="contractLoadError" role="alert">{{contractLoadError}}</p>
  <p *ngIf="pdfExportError" role="alert">{{pdfExportError}}</p>
  <p *ngIf="loadingContracts" aria-live="polite">Vertragsvorlagen werden geladen...</p>
  <mat-accordion multi>
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title> Zwischen</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="d-flex jcsb">
      <div>
        <h2>PHOENIX Pharmahandel GmbH & Co KG </h2>
        <p>Pfingstweidstraße 10-12</p>
        <p>68199 Mannheim</p>
        <p class="mt-5"> Ihr Anscprechpartner: </p>
      </div>
      <p>und</p>
      <div>
        <p>Apotheke</p>
        <h2>{{account.name}}</h2>
        <p>{{account.street}}</p>
        <p>{{account.zip_code ?? account.zipCode}} {{account.city}}</p>
        <p class="mt-5">Inhaber: {{account.owner?.salutation}} {{account.owner?.title}} {{account.owner?.first_name ?? account.owner?.firstName}} {{account.owner?.last_name ?? account.owner?.lastName}}</p>
        <p>Telefon: {{account.phone}}</p>
        <p>E-Mail: {{account.email}}</p>
        <p>IDF: {{account.idf}}</p>
      </div>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Vereinbarungen</mat-panel-title>
    </mat-expansion-panel-header>
    <div></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Artikelliste </mat-panel-title>

    </mat-expansion-panel-header>
      <mat-table  [dataSource]="contracts">
        <ng-container matColumnDef="position">
          <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.pos }}</mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="sku">
          <mat-header-cell *matHeaderCellDef> Artikelnummer </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.templateId}} </mat-cell>
          <mat-footer-cell *matFooterCellDef> </mat-footer-cell>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
          <mat-footer-cell *matFooterCellDef> Gesammtsummen </mat-footer-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="once">
          <mat-header-cell *matHeaderCellDef> Einmalig </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.price | currency}} </mat-cell>
          <mat-footer-cell *matFooterCellDef> {{totalOnce() | currency:'EUR'}} </mat-footer-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="monthly">
          <mat-header-cell *matHeaderCellDef> Monatlich </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.monthly | currency}} </mat-cell>
          <mat-footer-cell *matFooterCellDef> {{totalMonthly() | currency:'EUR'}} </mat-footer-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;"></mat-row>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </mat-table>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Vertragsbedingungen </mat-panel-title>

    </mat-expansion-panel-header>
    <div>Mit meiner Unterschrift auf dem Vertrag akzeptiere ich die folgenden Vertragskonditionen:
      <p *ngFor="let contract of contracts">{{contract.id}} | {{contract.name}} {{contract.description}}</p>
    </div>
  </mat-expansion-panel>
  </mat-accordion>

  <p>E-Mail-Adresse der Apotheke: {{account.email}}</p>

  <p>Der Vertragsschluss erfolgt durch elektronische Bestätigung bzw. digitale Unterschrift (Textform) des Vertragstextes durch den/die vertretungsberechtigten Apothekeninhaber/in.</p>

  <div class="d-flex jcsb mt-6">
    <div class="apotheke w-50">
      Datum, ort
      <canvas id="sign" #sign width="300" height="150"></canvas>
      <button mat-button id="clear" (click)="clearCanvas()">Clear canvas</button>
    </div>
    <div class="gvl d-flex jcsb w-50">
      Datum, ort
      <div>
      <img alt="Dr. Sven Simons" src="simons.png" height="50"/>
        <p>ppa. Dr. Sven Simons</p>
        <p>Leitung Marketing</p>
        <p>Deutschland</p>
      </div>
      <div>
        <img  alt="Michael Klein" src="klein.png" height="50"/>
        <p>ppa. Michael Klein</p>
        <p>Leitung Vertriebsunterstützung</p>
      </div>
    </div>
    <div><button (click)="createDocument()" [disabled]="loadingContracts || exportingPdf || !!contractLoadError || contracts.length === 0">Zahlungspflichtig abschließen</button></div>
  </div>
</div>
